import React from 'react';
import PropTypes from "prop-types";
import { TableCell, TableHead, TableRow, TableSortLabel } from "@material-ui/core";

export const TableHeadLineasMedicamentos = (props) => {

    const {
      order,
      orderBy,
      onRequestSort,
    } = props;
    
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    const headCells = [
      { id: "icons", align: "left", enabledSort: false, visible: true },
      { id: "carnet", disablePadding: true, label: "Carnet / Afiliado", align: "center", enabledSort: true, minWidth: 200, visible: true },
      // { id: "nroRegAB", disablePadding: false, label: "Nro Registro AB Medicamento", align: "left", enabledSort: true, visible: true },
      { id: "drogasMedicamento", disablePadding: false, label: "Drogas", align: "left", enabledSort: true, visible: true },
      { id: "presentacionMedicamento", disablePadding: false, label: "Presentacion", align: "left", enabledSort: true, visible: true },
      { id: "eliminar", align: "left", enabledSort: false, visible: true },
      { id: "fechaDispensa", disablePadding: false, label: "Fecha Receta", align: "left", enabledSort: true, minWidth: 150, visible: true },
      { id: "cantidad", disablePadding: false, label: "Cantidad", align: "left", enabledSort: false, minWidth: 125, visible: true },
      { id: "importeUnitFacturado", disablePadding: false, label: "Importe Unitario Facturado", align: "left", enabledSort: true, visible: true },
      { id: "subtotal", disablePadding: false, label: "Subtotal", align: "left", enabledSort: false, visible: true },
      { id: "importeMedicamentoTabla", disablePadding: false, label: "Importe Medic Tabla", align: "left", enabledSort: true, visible: true },
      { id: "porcenDto", disablePadding: false, label: "% Dto", align: "left", enabledSort: true, visible: false },
      { id: "debitoCapita", disablePadding: false, label: "Debito Cruzado", align: "left", enabledSort: true, visible: true },
      // { id: "fechaInternacionDesde", disablePadding: false, label: "Fecha Internación Desde", align: "left", enabledSort: false, visible: true },
      // { id: "fechaInternacionHasta", disablePadding: false, label: "Fecha Internación Hasta", align: "left", enabledSort: false, visible: true },
      { id: "nroValidacion", disablePadding: false, label: "Nro Validación", align: "left", enabledSort: true, visible: props.comprobanteSeleccionado.comprobanteContrato.efectorFacturacion.validaPortalPrestador },
      { id: "idSolicitud", disablePadding: false, label: "IdSolicitud", align: "left", enabledSort: true, visible: props.comprobanteSeleccionado.comprobanteContrato.efectorFacturacion.validaAutorizacion },
      // { id: "idCentroCosto", disablePadding: false, label: "Centro Costo", align: "left", enabledSort: false, visible: true },
      { id: "importeDebito", disablePadding: false, label: "Debito", align: "center", enabledSort: false, visible: true },
      { id: "total", disablePadding: false, label: "Total a Pagar", align: "center", enabledSort: false, visible: true },
      { id: "save", align: "left", enabledSort: false }
    ];

    return (
      <TableHead>
        <TableRow>
          {headCells.filter(s => s.visible).map((headCell) => (
            <TableCell
              key={headCell.id}
              align={headCell.align}
              padding={headCell.disablePadding ? "none" : "default"}
              sortDirection={orderBy === headCell.id ? order : false}
              style={{minWidth: headCell.minWidth}}
            >
              {headCell.enabledSort
                ?
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : "asc"}
                    onClick={createSortHandler(headCell.id)}
                  >
                    {headCell.label}
                  </TableSortLabel>
                :
                  <>{headCell.label}</>
              }
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
  
  TableHeadLineasMedicamentos.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
  };